export const yAxisLabelPlugin = {
  id: 'yAxisLabel',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  beforeDraw: (chart: any) => {
    const ctx = chart.ctx
    const chartArea = chart.chartArea
    const label = chart.options.plugins?.yAxisLabel?.label

    if (!label) return

    ctx.save()
    ctx.fillStyle = '#5D5D5D'
    ctx.font =
      'medium 12px Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    ctx.textAlign = 'left'
    ctx.textBaseline = 'top'

    const labelX = chartArea.left - 39
    const labelY = chartArea.top - 5

    ctx.fillText(label, labelX, labelY)

    const textMetrics = ctx.measureText(label)
    ctx.beginPath()
    ctx.moveTo(labelX, labelY + 12)
    ctx.lineTo(labelX + textMetrics.width, labelY + 12)
    ctx.strokeStyle = '#5D5D5D'
    ctx.lineWidth = 1
    ctx.stroke()

    ctx.restore()
  },
}
